<template>
  <v-form
    v-if="photos && appointment"
    ref="form">
    <tab-title
      :car-id="appointment.car.id"
      text="写真" />
    <v-flex md6>
      <v-alert
        :value="true"
        outline
        color="red lighten-1"
        class="mb-5"
      ><ul class="pl-3">
        <li>白トビ、黒ツブレ、ピンぼけ、指の映り込みは再撮影お願いします。</li>
        <li>撮影時はボンネットをきちんと閉めて撮影下さい。</li>
        <li>車検証・自賠責等をシートに置いたままの撮影はしないでください。</li>
      </ul>
      </v-alert>
    </v-flex>
    <photo-group
      :items="photosList"
      :photos="mainPhotos"
      @update-active="updateActiveCpPhoto"
    />
    <div class="display-1 my-5">追加写真</div>
    <v-flex md6>
      <v-alert
        :value="true"
        outline
        color="red lighten-1"
        class="mb-5"
      >※個人情報が映り込まないよう注意してください。
        <br>例) サンルーフ(開放状態)、フリップダウンモニター、各スイッチ(主に輸入車)など
      </v-alert>
    </v-flex>
    <photo-group
      :photos="additionalPhotos"
      additional
      @update-active="updateActiveCpPhoto"
    />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="damages#top">次へ</v-btn>
    <photo-selection
      v-if="activeCpPhoto"
      :init-selected="activeCpPhoto.selectedPhoto"
      :label="activeCpPhoto.label"
      :name="activeCpPhoto.name"
      @upload="uploadQuery"/>
  </v-form>
</template>

<script>
import { GET_PHOTOS, getCarWith } from '../../queries';
import PhotoGroup from '../../components/fields/PhotoGroup';
import PhotoSelection from '../../components/elements/PhotoSelection';

const photosList = [
  {
    name: 'body_front_right',
    label: '右フロント（全体）',
    caption: '・車両をフレームに収める<br>・オープンボンネットでの撮影NG',
    required: true,
  },
  {
    name: 'roof_front',
    label: 'ルーフフロント（車体右上）',
    caption: '・凹み、損傷が確認できるよう撮影する',
    required: true,
  },
  {
    name: 'body_front_left',
    label: '左フロント（全体）',
    caption: '・車両をフレームに収める<br>・オープンボンネットでの撮影NG',
    required: true,
  },
  {
    name: 'front_bottom',
    label: 'フロント下回り （車体前方左下）',
    caption: '・車体下回り、足回りが写るように撮影',
    required: true,
  },
  {
    name: 'front_left_wheel',
    label: '左フロントタイヤ',
    caption: '・サイズが分かるよう、フレームに収める',
    required: true,
  },
  {
    name: 'rear_left_wheel',
    label: '左リアタイヤ',
    caption: '・サイズが分かるよう、フレームに収める',
    required: true,
  },
  {
    name: 'left_step',
    label: 'ステップ左',
    caption: '・全体がフレームに収まるように後方から撮影',
    required: true,
  },
  {
    name: 'body_rear_left',
    label: '左リア（左後方全体）',
    caption: '・車両をフレームに収める',
    required: true,
  },
  {
    name: 'roof_back',
    label: 'ルーフリア（左上後方）',
    caption: '・凹み、損傷が確認できるよう撮影する',
    required: true,
  },
  {
    name: 'body_rear_right',
    label: '右リア（右後方全体）',
    caption: '・車両をフレームに収める',
    required: true,
  },
  {
    name: 'right_step',
    label: 'ステップ右',
    caption: '・全体がフレームに収まるように後方から撮影',
    required: true,
  },
  {
    name: 'rear_bottom',
    label: 'リア下回り（車体後方右下）',
    caption: '・排気口、車体下回り、足回りが写るように撮影',
    required: true,
  },
  {
    name: 'interior_seat_rear',
    label: 'リアシート',
    caption: '・座面の側部、背もたれの端まで撮影する',
    required: true,
  },
  {
    name: 'interior_panel',
    label: 'ダッシュボード',
    caption: '・ハンドル、ダッシュパネル全体を撮影（後部座席より）<br>・シフトが入るように撮影',
    required: true,
  },
  {
    name: 'interior_seat_front',
    label: 'フロントシート',
    caption: '・座面の側部、背もたれの端、可動レバー(電動スイッチ)まで映り込むように撮影する',
    required: true,
  },
  {
    name: 'ceiling',
    label: '天井',
    caption: '・中央部を中心に、できるだけ全体を撮影',
    required: true,
  },
  {
    name: 'interior_mileage',
    label: 'メーター',
    caption: '・メーターパネル全体を機関始動状態、積算計(ODO)表示で撮影',
    required: true,
  },
  {
    name: 'navigation',
    label: 'ナビ',
    caption: '・全体がフレームに収まるようにメニュー画面で撮影',
    required: true,
  },
  {
    name: 'service_book_keys',
    label: 'ブック関連',
    caption: '・個人情報が写りこまないように撮影',
    required: true,
  },
  {
    name: 'engine_compartment',
    label: 'エンジンルーム',
    caption: '・フェンダー先端、前端、後端まで撮影',
    required: true,
  },
  {
    name: 'trunk',
    label: 'ラゲッジスペース',
    caption: '・床面が写るように撮影',
    required: true,
  },
  {
    name: 'warranty_card',
    label: '保証書',
    caption: '・ディーラー印のある初回オーナーのページを撮影',
    required: true,
  },
  {
    name: 'caution_plate',
    label: 'コーションプレート',
    caption: '・英数字記号が判別可能な撮影',
    required: true,
  },
];

export default {
  components: {
    PhotoGroup,
    PhotoSelection,
  },
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    photos: {
      query: GET_PHOTOS,
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
    },
    appointment: {
      query: getCarWith(),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
    },
  },
  data() {
    return {
      photosList,
      activeCpPhoto: null,
    };
  },
  computed: {
    mainPhotos() {
      return this.photos.filter(p => p.type !== 'PHOTO_ADDITIONAL');
    },
    additionalPhotos() {
      return this.photos.filter(p => p.type === 'PHOTO_ADDITIONAL');
    },
    aiPhotos() {
      return this.$store.state.aiPhotos;
    },
  },
  watch: {
    aiPhotos(val, oldVal) {
      if (val.length > oldVal.length) {
        this.$apollo.queries.photos.refetch();
      }
    },
  },
  methods: {
    updateActiveCpPhoto({ photo, ref }) {
      if (!photo || !ref) return;
      this.activeCpPhoto = photo;
      this.activeCpPhoto.ref = ref;
      this.$store.commit('togglePhotoSelectionDialog');
    },
    uploadQuery(file) {
      if (!this.activeCpPhoto || !this.activeCpPhoto.ref) return;
      const { ref } = this.activeCpPhoto;

      if (this.activeCpPhoto.name === 'additional') {
        ref.uploadQuery(file);
      } else {
        ref[0].uploadQuery(file);
      }

      this.activeCpPhoto = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/PhotosTab.vue